module.exports = __webpack_public_path__ + "static/media/15.6a98d44c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/15.jpg
// module id = 548
// module chunks = 0